import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 卓の横で複数人が同時に入力する想定なので、少し短めに寝かせる
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          // 権限不足・不在・未実装はリトライしても結果が変わらない
          if (error.isUnauthorized || error.status === 404 || error.isNotImplemented) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
